import {useContext} from 'react';
import {TableContext} from '@common/ui/tables/table-context';
import {Track} from '@app/web-player/tracks/track';
import {Playlist} from '@app/web-player/playlists/playlist';

export interface TrackTableMeta {
  queueGroupId?: string | number;
  resolveQueueGroupId?: (
    track: Track,
    index: number,
  ) => string | number | undefined;
  hideTrackImage?: boolean;
  showArtistsInDescription?: boolean;
  hideUnreleasedDateInDescription?: boolean;
  playlist?: Playlist;
  onTrackPlay?: (track: Track, index: number) => void | Promise<void>;
  openInDialogTrigger?: boolean;
  closePlayerOverlayOnOpen?: boolean;
}

const stableObj = {};

export function useTrackTableMeta() {
  const {meta} = useContext(TableContext);
  return (meta || stableObj) as TrackTableMeta;
}
